import React, { useState } from 'react';
import { FormOutlined } from '@ant-design/icons';
import { Modal, DatePicker, Button, Form } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import { orderPurchaseSaveWarehouseQualityTime } from '../../../api';

const format = "YYYY-MM-DD HH:mm";

export default function Index(props) {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const handleOk = () => { };
  const handleCancel = () => { setOpen(false); };
  const onHandleFinish = async (values) => {
    const warehouse_quality_time = moment(values.warehouse_quality_time).format(format);
    const { order_no, } = props;
    const { updateWarehouseQualityTime = () => { } } = props;
    const { data: { code } } = await orderPurchaseSaveWarehouseQualityTime({ warehouse_quality_time, order_no });
    if (+code === 0) {
      setOpen(false);
      updateWarehouseQualityTime(warehouse_quality_time);
    }
  };
  return (
    <div>
      <span style={{ fontSize: 12, fontWeight: 'initial' }}>质检时间：{props.warehouse_quality_time} <FormOutlined onClick={() => setOpen(true)} /></span>
      <Modal width={300} open={open} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <Form form={form} name='quality-time' onFinish={onHandleFinish} initialValues={{ warehouse_quality_time: props.warehouse_quality_time ? moment(props.warehouse_quality_time) : null }}>
          <Form.Item label="质检时间" name="warehouse_quality_time" rules={[{ required: true, message: '请选择质检时间!' },]}><DatePicker locale={locale} showTime format={format} placeholder="请选择质检时间" showNow={false} /></Form.Item>
          <div style={{ display: 'flex', justifyContent: 'center' }}><Button type="primary" htmlType="submit">确定</Button></div>
        </Form>
      </Modal>
    </div >
  );
}
